var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"grid-records",attrs:{"color":"white","x-small":""}},[_vm._v(" "+_vm._s(_vm.$i18n.t("Showing"))+" "+_vm._s(_vm.table.from)+" - "+_vm._s(_vm.table.till)+" of "+_vm._s(_vm.table.records)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }